interface PageHeaderProps {
  children?: React.ReactNode;
}

/**
 * PageHeader component - displays action buttons on the right side
 *
 * NOTE: Breadcrumbs are now displayed in the TopBar via the useSetBreadcrumbs hook.
 * Use this component only for page-specific action buttons.
 *
 * @example
 * ```tsx
 * // In your page component:
 * useSetBreadcrumbs([
 *   { path: "/organizations", breadcrumb: "Organizations" },
 *   { path: `/location/${id}`, breadcrumb: locationName }
 * ]);
 *
 * return (
 *   <PageHeader>
 *     <Button>Add Machine</Button>
 *   </PageHeader>
 * );
 * ```
 */
const PageHeader = ({ children }: PageHeaderProps) => {
  if (!children) return null;

  return (
    <header className="flex h-16 shrink-0 items-center gap-2 px-4 justify-end">
      {children}
    </header>
  );
};

export default PageHeader;
